/**
 * Resolves the store id used for designer/staff filter queries.
 * When listing bridge is active, uses listing store only (empty = search all stores).
 * Otherwise falls back to account store.
 */
export const resolveDesignerEffectiveStoreId = ({
  isRegistered,
  listingStoreId,
  accountStoreId,
}) => {
  const account =
    accountStoreId != null && accountStoreId !== ''
      ? String(accountStoreId)
      : ''
  if (!isRegistered) {
    return account
  }
  if (listingStoreId != null && listingStoreId !== '') {
    return String(listingStoreId)
  }
  return ''
}
